module.exports = __webpack_public_path__ + "img/header-memoireRingsBestseller.78d4733.jpg";